document.addEventListener("DOMContentLoaded", function(){


  const buttons = document.querySelectorAll(
    ".vloxo-product-button"
  );


  if(!buttons.length) return;



  buttons.forEach(button => {


    button.addEventListener("click", function(event){


      event.preventDefault();



      const productId = this.dataset.variant;



      if(!productId) return;



      const originalText = this.innerHTML;



      this.innerHTML = "Adding...";

      this.style.opacity = "0.7";




      fetch("/cart/add.js",{

        method:"POST",

        headers:{

          "Content-Type":"application/json",

          "Accept":"application/json"

        },

        body:JSON.stringify({

          items:[

            {

              id:productId,

              quantity:1

            }

          ]

        })

      })


      .then(response=>response.json())


      .then(()=>{


        this.innerHTML="Added ✓";


        document.dispatchEvent(
          new CustomEvent(
            "cart:refresh"
          )
        );



        setTimeout(()=>{


          this.innerHTML=originalText;

          this.style.opacity="1";


        },2000);



      })


      .catch(()=>{


        this.innerHTML="Error";


        setTimeout(()=>{


          this.innerHTML=originalText;

          this.style.opacity="1";


        },2000);



      });



    });


  });


});